<template>
  <div class="flex items-center gap-3 px-4 h-[75px]">
    <a @click="gotoHome" class="flex items-center cursor-pointer shrink-0">
      <img class="w-10 h-10 object-contain" src="/logo/IOC-160X160.png" alt="Logo" />
    </a>
    
    <div class="flex flex-col justify-center min-w-0 pl-1">
      <span class="text-sm font-extrabold tracking-wide text-cyan-400 leading-tight uppercase">
        Innovare Optima<br />Consulting
      </span>
      <span class="text-[11px] font-medium text-gray-400 leading-tight mt-0.5 whitespace-nowrap">
        Broker Management System
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AmsSidebarHeader",
  methods: {
    gotoHome() {
      this.$router.push("/");
    },
  }
};
</script>
